import { FieldErrors, FieldValues } from 'react-hook-form';
import { Text } from '@bpba/ui-components';
import { FC } from 'react';
import { IIndexable } from '../../../model/IIndexable';

/**
 * @param fieldName: clave que identifica al campo dentro del formulario.
 * @param id: identificador asignado a este componente a nivel html.
 */
type Props<T extends FieldValues> = {
  fieldName: string;
  errorCollection?: FieldErrors<T>;
  id?: string;
};

export const GenericInputError: FC<Props<IIndexable>> = ({ fieldName, errorCollection, id }) => {
  let text = '&nbsp;'; /**Espacio en blanco inicialmente para evitar colapso de párrafo. */
  let ariaLabel = '';

  if (fieldName && errorCollection) {
    const fieldErrors = errorCollection[fieldName];

    if (fieldErrors?.message) {
      text = `*${fieldErrors.message}`;
      ariaLabel = fieldErrors.message.toString();
    }
  }

  return (
    <Text
      color="red"
      fontSize={'10px'}
      lineHeight="16px"
      margin="0"
      dangerouslySetInnerHTML={{ __html: text }}
      id={id}
      aria-label={ariaLabel}
    />
  );
};
